<template>
    <div class="line-chart">
      <apexchart :options="chartOptions" ref="chart" :series=raw></apexchart>
    </div>
  </template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import { onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'RangeChart',
  props: ['id', 'series', 'title', 'avgs', 'avgs2'],
  components: {
    apexchart: VueApexCharts
  },
  setup (props) {
    const chart = ref(null)
    onMounted(() => {
      setTimeout(() => {
        chart.value.updateSeries(props.series)
      }, 200)
    })
    const store = useStore()
    const chartOptions = computed(() => {
      const isDarkMode = store.state.theme.currentTheme === 'night'
      return {
        chart: {
          background: 'transparent',
          id: props.id,
          type: 'rangeBar'
        },
        animations: {
          enabled: false
        },
        yaxis: {
          decimalsInFloat: 3
        },
        dataLabels: {
          enabled: false
        },
        title: {
          text: props.title,
          style: {
            fontSize: '20px'
          }
        },
        colors: ['#F86624', '#008FFB'],
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const xLabel = w.globals.labels[dataPointIndex]
            const min = props.series[seriesIndex].data[dataPointIndex].y[0].toFixed(3)
            const max = props.series[seriesIndex].data[dataPointIndex].y[1].toFixed(3)
            const avg = props.avgs[dataPointIndex].toFixed(3)
            let firstItem = 'Left'
            let secondItem = 'Right'
            if (props.title === 'Reptitions') {
              firstItem = 'Off Device Reps'
              secondItem = 'Session Reps'
            }
            if (props.series.length === 2) {
              const min2 = props.series[1].data[dataPointIndex].y[0].toFixed(3)
              const max2 = props.series[1].data[dataPointIndex].y[1].toFixed(3)
              const avg2 = props.avgs2[dataPointIndex].toFixed(3)

              return `<div class="arrow_box">
                <div class="title"><span>${xLabel}</span></div>
                <div class="content">
                  <span style="color: #F86624;">${firstItem}:</span><br>
                  <span>Min: ${min}</span><br>
                  <span>Max: ${max}</span><br>
                  <span>Avg: ${avg}</span><br>
                  <span style="color: rgb(59,160,252);">${secondItem}:</span><br>
                  <span>Min: ${min2}</span><br>
                  <span>Max: ${max2}</span><br>
                  <span>Avg: ${avg2}</span>
                </div>
              </div>`
            }
            return '<div class="arrow_box">' + '<div class="title">' + '<span>' + xLabel + '</span>' + '</div>' + '<div class="content">' +
              '<span>' + `Min: ${min}` + '</span>' + '<span><br>' + `Max: ${max}` + '</span>' + '<span><br>' + `Avg: ${avg}` + '</span>' + '</div>' +
            '</div>'
          },
          enabled: true,
          shared: true,
          followCursor: true
        },
        theme: {
          mode: isDarkMode ? 'dark' : 'light'
        }
      }
    })
    return { chart, chartOptions }
  },
  data () {
    return {
      raw: [{
        data: []
      }]
    }
  }
}
</script>

  <style>

.arrow_box {
  position: relative;
  background: white;
}

.title {
  background: #eceff1;
  border-bottom: 1px solid #ddd;
  padding: 0 10px;
  font-size: 12px;
}

.content {
  padding: 0 10px;
  font-size: 12px;
}
  </style>
